import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CheckOutlined, HourglassOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Avatar, Button, Comment, Form, message, Popconfirm, Row, Space, Tooltip, Typography } from 'antd';
import { NotificationType, TaskIncidenceState } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getMediaStore } from 'core/modules/media/media.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { getUserStore } from 'core/modules/users/user.store';
import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskDeadline } from 'src/components/Tasks/Deadline';
import { classes } from 'src/utils/classes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/** This component shows all the incidences attached to a given task, in the drawer */
export var TaskDrawerIncidences = function TaskDrawerIncidences(_ref) {
  var task = _ref.task,
      onIncidenceSelected = _ref.onIncidenceSelected;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  var _getUserStore = getUserStore(),
      currentUser = _getUserStore.currentUser,
      getUserById = _getUserStore.getUserById;

  var _getTaskStore = getTaskStore(),
      deleteTaskIncidence = _getTaskStore.deleteTaskIncidence;

  var _getNotificationStore = getNotificationStore(),
      activeNotification = _getNotificationStore.activeNotification;

  var _getAuthStore = getAuthStore(),
      canManageTasks = _getAuthStore.canManageTasks;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var highlightedIncidenceId = useMemo(function () {
    if ((activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.content.type) !== NotificationType.TaskIncidenceAdded) {
      return;
    }

    return activeNotification.content.incidence;
  }, [activeNotification]);
  var incidences = useMemo(function () {
    return task.incidences.map(function (incidence) {
      return _objectSpread(_objectSpread({}, incidence), {}, {
        author: getUserById(incidence.authorId),
        formattedDate: moment(incidence.createdAt).format('DD/MM/YYY HH:mm'),
        fromNow: moment(incidence.createdAt).fromNow()
      });
    });
  }, [task.incidences]);
  return useMemo(function () {
    return /*#__PURE__*/_jsx(Container, {
      form: form,
      name: "comment",
      children: incidences.map(function (incidence) {
        var _incidence$author, _incidence$author2;

        return /*#__PURE__*/_jsx("div", {
          id: "incidence-".concat(incidence.id),
          children: /*#__PURE__*/_jsx(Comment, {
            author: (_incidence$author = incidence.author) === null || _incidence$author === void 0 ? void 0 : _incidence$author.name,
            avatar: /*#__PURE__*/_jsx(Avatar, {
              src: getUserMediaSrc(incidence.authorId),
              alt: (_incidence$author2 = incidence.author) === null || _incidence$author2 === void 0 ? void 0 : _incidence$author2.name
            }),
            content: /*#__PURE__*/_jsxs("div", {
              className: "comment-content",
              children: [/*#__PURE__*/_jsxs(Row, {
                align: "middle",
                justify: "space-between",
                className: "incidence-header",
                children: [/*#__PURE__*/_jsxs(Space, {
                  align: "center",
                  children: [incidence.state === TaskIncidenceState.Done ? /*#__PURE__*/_jsx(CheckOutlined, {
                    className: "icon-done"
                  }) : /*#__PURE__*/_jsx(HourglassOutlined, {
                    className: "icon-pending"
                  }), /*#__PURE__*/_jsx(Typography.Title, {
                    level: 5,
                    children: incidence.title
                  })]
                }), /*#__PURE__*/_jsx(TaskDeadline, {
                  deadline: incidence.deadline
                })]
              }), /*#__PURE__*/_jsx("p", {
                children: incidence.description
              })]
            }),
            className: classes({
              highlighted: incidence.id === highlightedIncidenceId
            }),
            datetime: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Tooltip, {
                title: incidence.formattedDate,
                children: /*#__PURE__*/_jsx("span", {
                  children: incidence.fromNow
                })
              }), (canManageTasks || task.assignedToUserId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || task.reviewerId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) && /*#__PURE__*/_jsx(Button, {
                type: "link",
                className: "edit-button",
                onClick: function onClick() {
                  return onIncidenceSelected(incidence.id);
                },
                children: t('edit')
              }), canManageTasks && /*#__PURE__*/_jsx(Popconfirm, {
                getPopupContainer: function getPopupContainer(trigger) {
                  return trigger.parentElement;
                },
                title: t('areYouSure'),
                icon: /*#__PURE__*/_jsx(QuestionCircleOutlined, {
                  style: {
                    color: 'red'
                  }
                }),
                okText: t('yes'),
                cancelText: t('cancel'),
                onConfirm: function onConfirm() {
                  return deleteTaskIncidence(task.id, incidence.id)["catch"](function () {
                    message.error(t('unknownError'));
                  });
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  className: "remove-button",
                  children: t('delete')
                })
              }, "remove")]
            })
          })
        }, incidence.id);
      })
    });
  }, [incidences, media]);
}; // Styles

var Container = styled(Form).withConfig({
  displayName: "Incidences__Container",
  componentId: "sc-1gfs538-0"
})([".ant-comment-content-author{align-items:center;.ant-comment-content-author-time{display:block;.ant-btn{line-height:5px;height:auto;font-size:12px;padding-top:0;padding-bottom:0;}}}.ant-comment{margin-left:-16px;margin-right:-16px;padding-left:16px;padding-right:16px;&.highlighted{background-color:", ";color:", ";.ant-comment-content-author *{color:", " !important;}}}.edit-button,.remove-button{padding:0 6px;}.edit-button{margin-left:12px;}.icon-done{svg *{fill:", ";}}.icon-pending{svg *{fill:", ";}}.ant-typography{margin:0;}.incidence-header{margin:6px 0px;}"], Colors.lightestPrimary, Colors.primary, Colors.lightPrimary, Colors.success, Colors.orange[4]);